import { DEFAULT_DATA_POINT_RADIUS } from '../../../../../core/constants.js';
import { PointsDisplay } from '../../../../types/timeseries-props.js';

const DEFAULT_POINT_WIDTH = DEFAULT_DATA_POINT_RADIUS * 2;
const MINIMUM_POINT_DISTANCE = DEFAULT_POINT_WIDTH * 2;

const POINT_SPACE_CONSUMPTION = DEFAULT_POINT_WIDTH + MINIMUM_POINT_DISTANCE;

/**
 * Checks the value of pointsDisplay and returns a boolean whether the points
 * should be displayed or not.
 *
 * @param pointsDisplay - given pointsDisplay prop
 * @param chartWidth - given chart width
 * @param numOfDataPoints - total amount of dataPoints
 * @returns
 */
export function shouldDisplayPoints(
  pointsDisplay: PointsDisplay,
  chartWidth: number,
  numOfDataPoints: number,
): boolean | number {
  switch (pointsDisplay) {
    case 'always': {
      return true;
    }
    case 'never': {
      return false;
    }
    default: {
      const maxDataPoints = chartWidth / POINT_SPACE_CONSUMPTION;

      return numOfDataPoints < maxDataPoints;
    }
  }
}
